import { render, staticRenderFns } from "./AttachmentUploader.vue?vue&type=template&id=a9ea8722&scoped=true&"
import script from "./AttachmentUploader.vue?vue&type=script&lang=js&"
export * from "./AttachmentUploader.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentUploader.vue?vue&type=style&index=0&id=a9ea8722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ea8722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9ea8722')) {
      api.createRecord('a9ea8722', component.options)
    } else {
      api.reload('a9ea8722', component.options)
    }
    module.hot.accept("./AttachmentUploader.vue?vue&type=template&id=a9ea8722&scoped=true&", function () {
      api.rerender('a9ea8722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_Attachments/AttachmentUploader.vue"
export default component.exports